export namespace VeranstaltungsTypenConstants {
    export const BOUNDED_CONTEXT_NAME = 'VeranstaltungsTypen';
    
}

